
<template>
  <div class="modal_card">
    <div class="header">
      <h4 class="title">
        {{ translate("tariffication.add_tariff") }}
      </h4>
    </div>
    <div class="content">
      <div class="row dates">
        <div class="col-md-5">
          <WrapDatePicker
              v-model="new_tariff.date_start"
              type="date"
              :range="false"
              :confirm="false"
              value_type="YYYY-MM-DD"
              :disabled_date="['- 2 month', '+ 1 month']"
              :placeholder="translate('tariffication.date_start')"
              :label="translate('tariffication.date_start')"
          />
        </div>
        <div class="col-md-5">
          <WrapDatePicker
              v-model="new_tariff.date_end"
              type="date"
              :range="false"
              :confirm="false"
              value_type="YYYY-MM-DD"
              :disabled_date="['- 2 month', '+ 1 month']"
              :placeholder="translate('tariffication.date_end')"
              :label="translate('tariffication.date_end')"
          />
        </div>
        <div class="col-md-2">
          <div class="filter checkbox">
            <div class="info">
              {{ translate("tariffication.trial") }}
            </div>
            <label class="switch" @click.prevent="update_trial()">
              <input type="checkbox" v-model="new_tariff.trial" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-8">
          <label> {{ translate("tariffication.client_name") }} </label>
          <tree-select
            :options="client_list"
            :multiple="false"
            v-model="new_tariff.client_id"
            :placeholder="translate('tariffication.client_name')"
            :clearable="false"
          />
        </div>

        <div class="col-md-4">
          <label> {{ translate("tariffication.simcard_count") }} </label>
          <tree-select
              :options="simcard_counts"
              :multiple="false"
              v-model="new_tariff.simcard_count"
              :placeholder="translate('tariffication.simcard_count')"
              :clearable="false"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <fg-input
            v-model="new_tariff.name"
            type="text"
            :label="translate('tariffication.tariff_name')"
            :placeholder="translate('tariffication.tariff_name')"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-2">
          <div class="filter checkbox">
            <div class="info">
              {{ translate("tariffication.nds") }}
            </div>
            <label class="switch" @click.prevent="new_tariff.nds = !new_tariff.nds">
              <input type="checkbox" v-model="new_tariff.nds" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
        <div class="col-md-3">
          <fg-input
            v-model="new_tariff.cost" type="number"
            :label="label_cost"
            :placeholder="label_cost"
          />
        </div>
        <div class="col-md-2">
          <label> {{ translate("tariffication.cost_currency") }} </label>
          <tree-select :options="currency_list" :multiple="false" v-model="new_tariff.cost_currency"
            :placeholder="translate('tariffication.cost_currency')" :clearable="false" />
        </div>

        <div class="col-md-5">
          <label> {{ translate("tariffication.rate_day") }} </label>
          <tree-select :options="rate_day_list" :multiple="false" v-model="new_tariff.rate_day"
                       :placeholder="translate('tariffication.rate_day')" :clearable="false" />
        </div>
      </div>

      <div class="services">
        <div class="item">
          <div class="filter checkbox">
            <div class="info">
              {{ translate("tariffication.traffic") }}
            </div>
            <label
                class="switch"
                @click.prevent="
                new_tariff.traffic = !new_tariff.traffic;
                new_tariff.trial = false;
              "
            >
              <input type="checkbox" v-model="new_tariff.traffic" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>

        <div class="item">
          <div class="filter checkbox">
            <div class="info">
              {{ translate("tariffication.remote_sim") }}
            </div>
            <label
                class="switch"
                @click.prevent="
                new_tariff.remote_sim = !new_tariff.remote_sim;
                new_tariff.trial = false;
              "
            >
              <input type="checkbox" v-model="new_tariff.remote_sim" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
        <div class="item">
          <div class="filter checkbox">
            <div class="info">
              {{ translate("tariffication.roaming_traffic") }}
            </div>
            <label
                class="switch"
                @click.prevent="
                new_tariff.roaming_traffic = !new_tariff.roaming_traffic;
                new_tariff.trial = false;
              "
            >
              <input type="checkbox" v-model="new_tariff.roaming_traffic" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
        <div class="item">
          <div class="filter checkbox">
            <div class="info">
              {{ translate("tariffication.cash") }}
            </div>
            <label
                class="switch"
                @click.prevent="
                new_tariff.cash = !new_tariff.cash;
                new_tariff.trial = false;
              "
            >
              <input type="checkbox" v-model="new_tariff.cash" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>{{ translate("tariffication.tariff_descr") }}</label>
            <textarea
              v-model="new_tariff.descr"
              rows="3"
              class="form-control border-input"
              :placeholder="translate('tariffication.tariff_descr')"
            />
          </div>
        </div>
      </div>

      <div class="text-center">
        <span
          class="btn btn-info btn-fill btn-wd"
          @click.prevent="create_tariff()"
          style="margin: 5px"
        >
          {{ translate("btn.add") }}
        </span>
        <span
          type="submit"
          class="btn btn-danger btn-fill btn-wd"
          @click.prevent="cancel"
          style="margin: 5px"
        >
          {{ translate("close_modal") }}
        </span>
      </div>
      <div class="clearfix" />
    </div>
  </div>
</template>
<script>
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: "CreateTariff",
  components: {WrapDatePicker},
  data() {
    return {
      new_tariff: {
        client_id: null,
        name: "",
        cost: "",
        descr: "",
        ts_end: null,
        rent: true,
        purchase: false,
        traffic: true,
        support: true,
        additional_service: false,
        aggregation: false,
        trial: false,
        remote_sim: false,
        roaming_traffic: false,
        cash: false,
        date_start: '',
        date_end: '',
        simcard_count: 1,
        nds: false,
        rate_day: 1
      },
    };
  },

  computed: {
    label_cost(){
      return `${this.translate('tariffication.tariff_cost')} ${this.new_tariff.nds ? this.translate('tariffication.with_nds') : this.translate('tariffication.without_nds')}`
    },
    client_list() {
      let list = [{ id: "", label: "Not selected", isDisabled: true, active: 0 }];
      let clients = this.$store.getters.getClientsList.map((client) => {
        return { id: client.id, label: client.name, active: client.active }
      })
      return list.concat(clients.filter((item) => item.active !== 0))
    },
    currency_list() {
      return [
        { id: "", label: "Not selected", isDisabled: true },
        { id: "RUB", label: "RUB" },
        { id: "EUR", label: "EUR" },
        { id: "USD", label: "USD" }
      ];
    },
    rate_day_list() {
      return [
        { id: 1, label: "с первого дня после отчетного периода" },
        { id: -1, label: "с последнего дня отчетного периода" },
      ];
    },

    simcard_counts() {
      let list = []
      for (let i = 0; i <= 8; i++) {
        list.push({ id: i, label: i })
      }
      return list;
    },
  },

  methods: {
    cancel() {
      this.$emit("close");
    },
    create_tariff() {
      this.$http.v1.createTariff(this.new_tariff, (response) => {
        this.global_notify("info", this.translate("tariffication.tariff_added"));
        this.$router.push({path: '/tariff/' + response.data.id})
        this.$emit("confirm");
      })
    },
    update_trial() {
      this.new_tariff.trial = !this.new_tariff.trial;
      if (this.new_tariff.trial) {
        this.new_tariff.rent = false
        this.new_tariff.purchase = false
        this.new_tariff.support = false
        this.new_tariff.traffic = false
        this.new_tariff.additional_service = false
        this.new_tariff.aggregation = false
        this.new_tariff.remote_sim = false
        this.new_tariff.roaming_traffic = false
        this.new_tariff.cash = false
        this.new_tariff.cost = 0
        this.new_tariff.cost_currency = 'RUB'
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.modal_card {
  width: 100%;
  border-radius: 3px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  color: #252422;
  position: relative;
  border: 1px solid #ccc;
  min-height: 85px;
  background-color: #f8f8f8;
  padding: 10px;

  .header {
    .title {
      margin-top: 15px;
    }
  }

  .content{
    .dates{
      margin-bottom: 10px;
    }
    .services{
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-wrap: wrap;
      .item{
        width: 25%;
      }
    }
  }
  .filter.checkbox {
    min-width: auto;
  }
}
</style>
